import { Component } from '@angular/core';

@Component({
  templateUrl: 'welcome-page.html',
  styleUrls: ['welcome-page.scss'],
})
export class WelcomePageComponent {
  constructor() {
  }


}


// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/sample/containers/welcome-page/welcome-page.ts